import type { CellCoordinate, TableCellAdapter } from 'ui/components/HourlyDataTable/HourlyDataTable.types'
import { getDayAheadBidCellKey, parseDayAheadBidCellKey } from './DayAheadBidTable.grid.helper'
import type { DayAheadBidColumn, DayAheadBidRow } from './DayAheadBidTable.types'

export function makeDayAheadBidTableAdapter(columns: DayAheadBidColumn[], rows: DayAheadBidRow[]): TableCellAdapter {
  return {
    columnCount: columns.length,
    rowCount: rows.length,
    getCoordinate(cellKey: string): CellCoordinate | null {
      const parsed = parseDayAheadBidCellKey(cellKey)
      if (!parsed || parsed.rowIndex >= rows.length) {
        return null
      }

      const columnIndex = columns.findIndex((column) => column.tagId === parsed.tagId)

      return columnIndex < 0 ? null : { rowIndex: parsed.rowIndex, columnIndex }
    },
    getCellKey(coord: CellCoordinate): string | null {
      if (
        coord.rowIndex < 0 ||
        coord.rowIndex >= rows.length ||
        coord.columnIndex < 0 ||
        coord.columnIndex >= columns.length
      ) {
        return null
      }

      return getDayAheadBidCellKey(coord.rowIndex, columns[coord.columnIndex].tagId)
    },
  }
}
